/* eslint-disable */
import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";

const OrderDetailsPopup = ({ orderId, setOrderId = () => {} }) => {
  const { t } = useTranslation();
  const offcanvasBodyRef = useRef(null);

  const token = localStorage.getItem("token");
  const ecosystemLogo = localStorage.getItem("ecosystemlogo");

  const [isLoading, setIsLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});

  //* function for get the invoice details
  const getInvoiceDetails = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_INVOICE_DETAILS +
        `/${orderId}` +
        `?token=${token}`;

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("invoice details ----->", response);

      if (response.status) {
        setOrderDetails(response.data);
      }
    } catch (error) {
      console.log("error", error.message);
    }
  };

  const resetHandler = () => {
    setOrderId(null);
    setOrderDetails({});
  };

  useEffect(() => {
    if (orderId) {
      getInvoiceDetails();
    }
  }, [orderId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasOrderDetails"
      aria-labelledby="offcanvasOrderDetailsLabel"
    >
      <div
        className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300"
        style={{
          boxShadow: "0 2px 8px rgba(44,62,80,0.08)",
        }}
      >
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              receipt_long
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasOrderDetailsLabel"
              style={{ letterSpacing: "0.5px" }}
            >
              Order Details
            </h3>
            <p className="text-white fs-sm mb-0 mt-2 opacity-75">
              View order details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div
        className="offcanvas-body p-4"
        ref={offcanvasBodyRef}
        style={{
          background: "linear-gradient(135deg, #f8fafc 0%, #f3f4f6 100%)",
        }}
      >
        <div
          className="p-3 p-md-4 border border-gray-200 rounded-15 shadow bg-white h-100 overflow-y-scroll mb-0"
          style={{ minHeight: 520 }}
        >
          {isLoading ? (
            <div>
              {/* Bootstrap Glow Placeholder */}
              <div className="placeholder-glow mb-3">
                <span className="placeholder col-6"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-2"></span>
              </div>
              <div className="row mb-4">
                <div className="col-md-4">
                  <div className="placeholder-glow">
                    <span className="placeholder col-7 mb-2"></span>
                    <span className="placeholder col-5"></span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="placeholder-glow">
                    <span className="placeholder col-8 mb-2"></span>
                    <span className="placeholder col-6"></span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="placeholder-glow">
                    <span className="placeholder col-8 mb-2"></span>
                    <span className="placeholder col-6"></span>
                  </div>
                </div>
              </div>
              <div className="table-responsive mb-4">
                <table
                  className="table table-bordered align-middle mb-0"
                  style={{ minWidth: 600 }}
                >
                  <thead className="bg-light">
                    <tr>
                      <th>
                        <span className="placeholder col-4"></span>
                      </th>
                      <th>
                        <span className="placeholder col-2"></span>
                      </th>
                      <th>
                        <span className="placeholder col-2"></span>
                      </th>
                      <th>
                        <span className="placeholder col-2"></span>
                      </th>
                      <th>
                        <span className="placeholder col-2"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(2)].map((_, i) => (
                      <tr key={i}>
                        <td>
                          <span className="placeholder col-4"></span>
                        </td>
                        <td>
                          <span className="placeholder col-2"></span>
                        </td>
                        <td>
                          <span className="placeholder col-2"></span>
                        </td>
                        <td>
                          <span className="placeholder col-2"></span>
                        </td>
                        <td>
                          <span className="placeholder col-2"></span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="row mt-5">
                <div className="col-md-8"></div>
                <div className="col-md-4">
                  <div className="placeholder-glow mb-1">
                    <span className="placeholder col-6"></span>
                    <span className="placeholder col-2"></span>
                  </div>
                  <div className="placeholder-glow mb-1">
                    <span className="placeholder col-6"></span>
                    <span className="placeholder col-2"></span>
                  </div>
                  <div className="placeholder-glow fw-bold fs-5 mt-2">
                    <span className="placeholder col-8"></span>
                    <span className="placeholder col-2"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Invoice Header */}
              <div className="d-flex justify-content-between align-items-start mb-4 pb-2 border-bottom border-gray-200">
                <div>
                  <img
                    src={url.SERVER_URL + ecosystemLogo}
                    alt="Lobees Logo"
                    style={{
                      maxHeight: "32px",
                      borderRadius: "6px",
                      boxShadow: "0 1px 4px rgba(44,62,80,0.08)",
                    }}
                  />
                  <div
                    className="mt-2 text-muted"
                    style={{ fontSize: "0.97rem", lineHeight: "1.7" }}
                  >
                    Calle de Embajadores, 9, 28012, Madrid, España
                    <br />
                    <span className="text-primary">
                      support@elpavonteatro.es
                    </span>
                    <br />
                    <span className="text-primary">(+34) 615 43 94 22</span>
                    <br />
                    <a
                      href="https://club.elpavonteatro.es/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-primary"
                    >
                      https://club.elpavonteatro.es/
                    </a>
                  </div>
                </div>
                <div className="text-end">
                  <div className="mb-2">
                    <b className="text-dark">Order Number:</b>{" "}
                    <span className="text-danger fw-bold">
                      {orderDetails?.orderid}
                    </span>
                  </div>
                  <div>
                    <b className="text-dark">Amount Payable:</b>{" "}
                    <span className="text-success fw-bold">
                      {orderDetails?.amount} €
                    </span>
                  </div>
                </div>
              </div>

              {/* Invoice Info */}
              <div className="row mb-4">
                <div className="col-md-4 mb-3 mb-md-0">
                  <div className="fw-bold mb-2 text-primary">
                    Seller Information
                  </div>
                  <div className="text-dark">{orderDetails?.ownername}</div>
                  <div className="text-muted">
                    {orderDetails?.storeowneremail}
                  </div>
                </div>
                <div className="col-md-4 mb-3 mb-md-0">
                  <div className="fw-bold mb-2 text-primary">
                    Order Information
                  </div>
                  <div className="d-flex mb-1">
                    <div style={{ width: 110 }} className="text-muted">
                      Invoice No:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.invoiceid}
                    </div>
                  </div>
                  <div className="d-flex mb-1">
                    <div style={{ width: 110 }} className="text-muted">
                      Order Date:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.invoicedate
                        ? getDateFormatInSpanish(orderDetails?.invoicedate)
                        : "--"}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: 110 }} className="text-muted">
                      Due Date:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.duedate
                        ? getDateFormatInSpanish(orderDetails?.duedate)
                        : "--"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="fw-bold mb-2 text-primary">
                    Payment Information
                  </div>
                  <div className="d-flex mb-1">
                    <div style={{ width: 80 }} className="text-muted">
                      Status:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.paymentstatus}
                    </div>
                  </div>
                  <div className="d-flex mb-1">
                    <div style={{ width: 80 }} className="text-muted">
                      Amount:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.amount} €
                    </div>
                  </div>
                  <div className="d-flex">
                    <div style={{ width: 80 }} className="text-muted">
                      Payment Date:
                    </div>
                    <div className="bg-gray-100 px-2 rounded text-dark fw-semibold">
                      {orderDetails?.paymentdate}
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="table-wrapper pb-4 mb-4 border-bottom border-gray-200 rounded-10 bg-light">
                <div className="table-responsive mb-1">
                  <table
                    className="table align-middle fs-sm text-nowrap border-0 mb-0"
                    style={{ borderRadius: "10px", overflow: "hidden" }}
                  >
                    <thead>
                      <tr style={{ background: "#f3f4f6" }}>
                        <th
                          width="40%"
                          className="bg-transparent fs-md fw-semibold border-0 text-primary"
                          style={{ fontSize: "1rem", padding: "12px 8px" }}
                        >
                          Description
                        </th>
                        <th
                          className="bg-transparent fs-md fw-semibold border-0 text-primary"
                          style={{ fontSize: "1rem", padding: "12px 8px" }}
                        >
                          Quantity
                        </th>
                        <th
                          className="bg-transparent fs-md fw-semibold border-0 text-primary"
                          style={{ fontSize: "1rem", padding: "12px 8px" }}
                        >
                          Price
                        </th>
                        <th
                          width="15%"
                          className="bg-transparent fs-md fw-semibold border-0 text-primary"
                          style={{ fontSize: "1rem", padding: "12px 8px" }}
                        >
                          Tax (IVA)
                        </th>
                        <th
                          className="bg-transparent fs-md fw-semibold border-0 text-primary"
                          style={{ fontSize: "1rem", padding: "12px 8px" }}
                        >
                          Total Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderDetails?.invoiceitems?.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            style={{
                              verticalAlign: "top",
                              background: index % 2 === 0 ? "#fff" : "#f8fafc",
                            }}
                          >
                            <td className="border-bottom-0 p-2 text-dark">
                              {item.description}
                            </td>
                            <td className="border-bottom-0 p-2 text-dark">
                              {item.unit}
                            </td>
                            <td className="border-bottom-0 p-2 text-dark">
                              {item.price}
                            </td>
                            <td className="border-bottom-0 p-2 text-dark">
                              {item.taxpercent}% IVA
                            </td>
                            <td className="border-bottom-0 p-2 text-dark">
                              {item.totalprice}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Totals */}
              <div className="row mt-4">
                <div className="col-md-8"></div>
                <div className="col-md-4">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="fw-semibold text-muted">
                      Total Discount
                    </span>
                    <span className="fw-bold text-dark">
                      {orderDetails?.totaldiscount}€
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="fw-semibold text-muted">
                      Total Tax (VAT)
                    </span>
                    <span className="fw-bold text-dark">
                      {orderDetails?.totaltax}€
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-between fw-bold fs-5 mt-3 py-2 px-2 rounded-8"
                    style={{ background: "#eafaf1" }}
                  >
                    <span className="text-success">Total Payable Amount</span>
                    <span className="text-success">
                      {orderDetails?.totalpayble}€
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPopup;
